import React, { useContext, useRef, useState } from 'react'
import './Contact.css'
import logolinkedin from '../../img/logolinkedin.png'
import sobre from '../../img/sobre.png'
import emailjs from 'emailjs-com'
import { ThemeContext } from '../../context'
function Contact() {

    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    const formRef = useRef();
    const [done, setDone] = useState(false)
    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_cn4fysl', 'template_9zizxxo', formRef.current, 'gLQGLKn9JCFZsAD1O')
            .then((result) => {
                console.log(result.text);
                setDone(true);
            }, (error) => {
                console.log(error.text);
            });
    };


    return (
        <div className="c">
            <div className="c-bg"></div>
            <div className="c-wrapper">
                <div className="c-left">
                    <h1 className="c-title">Contact Me</h1>
                    <div className="c-info">
                        <div className="c-info-item">
                            <a href="https://www.linkedin.com/in/alejandro-losada-1a341868/" target="_blank" rel="noreferrer">
                                <img src={logolinkedin} alt="logo" className="c-icon" />
                            </a>
                        </div>
                        <div className="c-info-item">
                            <img src={sobre} alt="logo" className="c-icon" />
                            alexlosada1992@gmail.com
                        </div>
                    </div>
                </div>
                <div className="c-right">
                    <p className="c-desc">
                        <b>What's your adventure for me?</b> I will reply as fast as I can!
                    </p>
                    <form ref={formRef} onSubmit={handleSubmit}>
                        <input style={{ backgroundColor: darkMode && '#2f2f2f' }} type="text" placeholder="Name" name="user_name" />
                        <input style={{ backgroundColor: darkMode && '#2f2f2f' }} type="text" placeholder="Subject" name="user_subject" />
                        <input style={{ backgroundColor: darkMode && '#2f2f2f' }} type="text" placeholder="Email" name="user_email" />
                        <textarea rows="5" placeholder="Message" name="message" style={{ backgroundColor: darkMode && '#2f2f2f' }} />
                        <button>Submit</button>
                        {done && "Thank you :D"}
                    </form>
                </div>
            </div>

        </div>
    )
}

export default Contact